﻿/// <reference path="mutations.js" />

import Vue from 'vue'

export const RESET_CREDIT_AGREEMENT_ITEM = (state, data) => {
    for (let i = 0; i < state.creditAgreement.subscriptionAgreementItems.length; i++) {
        if (state.creditAgreement.subscriptionAgreementItems[i].id === data.id) {
            if (data.fullReset === "yes") {
                state.creditAgreement.subscriptionAgreementItems[i].paymentBy = 'cash';
                state.creditAgreement.subscriptionAgreementItems[i].upfrontPayment = getTotalPricePerSubscription(state.creditAgreement.subscriptionAgreementItems[i]) - getTotalDiscountPerSubscription(state.creditAgreement.subscriptionAgreementItems[i]); // state.creditAgreement.subscriptionAgreementItems[i].price - state.creditAgreement.subscriptionAgreementItems[i].discount;               
            } else if (data.fullReset === "partial") {
                state.creditAgreement.subscriptionAgreementItems[i].upfrontPayment = 0;
            } else {
                // Empty
            }

            state.creditAgreement.subscriptionAgreementItems[i].monthlyPayment = 0
            state.creditAgreement.subscriptionAgreementItems[i].numberOfInstallments = 0
            state.creditAgreement.subscriptionAgreementItems[i].lastInstallment = 0;
        }
    }

    UPDATE_CREDIT_AGREEMENT_OVERVIEW_TOTALS(state);
}
export const RESET_CREDIT_AGREEMENT_ITEM_BY_ORDER = (state, data) => {

    let upfrontAmount = 0;
    if (data.fullReset === "yes") {
        state.order.paymentBy = 'cash';
        for (let item = 0; item < state.creditAgreement.subscriptionAgreementItems.length; item++) {
            upfrontAmount += getTotalPricePerSubscription(state.creditAgreement.subscriptionAgreementItems[item]); // state.creditAgreement.subscriptionAgreementItems[i].price - state.creditAgreement.subscriptionAgreementItems[i].discount;
        }
        state.creditAgreement.upfrontAmount = upfrontAmount - state.order.discount;
    } else if (data.fullReset === "partial") {
        state.creditAgreement.upfrontAmount = 0;
    } else {
        state.creditAgreement.upfrontAmount = 0;
    }
    state.creditAgreement.monthlyPayment = 0;
    state.creditAgreement.numberOfInstallments = 0;
    state.creditAgreement.lastInstallment = 0;
    UPDATE_CREDIT_AGREEMENT_OVERVIEW_TOTALS_BY_ORDER(state);
}
function getTotalPricePerSubscription(subscriptionAgreementItem) {
    let sum = 0;

    for (let i = 0; i < subscriptionAgreementItem.hardwareItems.length; i++) {
        sum += subscriptionAgreementItem.hardwareItems[i].price;
    }

    return sum;
}

function getTotalDiscountPerSubscription(subscriptionAgreementItem) {
    let sum = 0;

    for (let i = 0; i < subscriptionAgreementItem.hardwareItems.length; i++) {
        sum += subscriptionAgreementItem.hardwareItems[i].discount;
    }

    return sum;
}

function setPaymentDetailsByOrder(state) {
    for (let i = 0; i < state.creditAgreement.subscriptionAgreementItems.length; i++) {
        state.creditAgreement.monthlyPayment += Number(state.creditAgreement.subscriptionAgreementItems[i].monthlyPayment);
        state.creditAgreement.lastInstallment += Number(state.creditAgreement.subscriptionAgreementItems[i].lastInstallment);
        state.creditAgreement.upfrontAmount += Number(state.creditAgreement.subscriptionAgreementItems[i].upfrontPayment)
    }
    state.order.paymentBy = state.creditAgreement.subscriptionAgreementItems[0].paymentBy;
    state.creditAgreement.numberOfInstallments = state.creditAgreement.subscriptionAgreementItems[0].numberOfInstallments;
}

export const RESET_CREDIT_AGREEMENT_OVERVIEW = (state) => {
    for (let i = 0; i < state.creditAgreement.subscriptionAgreementItems.length; i++) {
        if (!state.order.useNewDiva)
            RESET_CREDIT_AGREEMENT_ITEM(state, { 'id': state.creditAgreement.subscriptionAgreementItems[i].id, 'fullReset': "yes" });
        else
            RESET_CREDIT_AGREEMENT_ITEM_BY_ORDER(state, { 'id': state.creditAgreement.subscriptionAgreementItems[i].id, 'fullReset': "yes" });
    }
}

export const UPDATE_CREDIT_AGREEMENT_OVERVIEW_TOTALS = (state) => {
    state.creditAgreement.totalCredit = 0;
    state.creditAgreement.totalPerMonth = 0;
    state.creditAgreement.payNow = 0;

    for (let i = 0; i < state.creditAgreement.subscriptionAgreementItems.length; i++) {
        state.creditAgreement.totalCredit += getTotalPricePerSubscription(state.creditAgreement.subscriptionAgreementItems[i]) - getTotalDiscountPerSubscription(state.creditAgreement.subscriptionAgreementItems[i]) - Number(state.creditAgreement.subscriptionAgreementItems[i].upfrontPayment);
        state.creditAgreement.totalPerMonth += Number(state.creditAgreement.subscriptionAgreementItems[i].monthlyPayment);
        state.creditAgreement.payNow += Number(state.creditAgreement.subscriptionAgreementItems[i].upfrontPayment);
    }

    state.creditAgreement.totalCredit = Number(state.creditAgreement.totalCredit.toFixed(2));
    state.creditAgreement.totalPerMonth = Number(state.creditAgreement.totalPerMonth.toFixed(2));
    state.creditAgreement.payNow = Number(state.creditAgreement.payNow.toFixed(2));
}
export const UPDATE_CREDIT_AGREEMENT_OVERVIEW_TOTALS_BY_ORDER = (state) => {
    let totalCredit = 0;
    let totalPerMonth = 0;
    let payNow = 0;

    for (let item = 0; item < state.creditAgreement.subscriptionAgreementItems.length; item++) {
        totalCredit += getTotalPricePerSubscription(state.creditAgreement.subscriptionAgreementItems[item]);
    }

    totalCredit = totalCredit - state.order.discount - Number(state.creditAgreement.upfrontAmount);
    payNow = (Number(state.creditAgreement.upfrontAmount) != 0 || state.order.paymentBy === "credit") ? Number(state.creditAgreement.upfrontAmount) : Number(totalCredit);
    totalPerMonth = Number(state.totalMonthlyInstallment);

    state.creditAgreement.totalCredit = Number(totalCredit.toFixed(2));
    state.creditAgreement.totalPerMonth = Number(totalPerMonth.toFixed(2));
    state.creditAgreement.payNow = Number(payNow.toFixed(2));
    HIDE_LOADER(state);
}

export const GET_ORDER = (state, orderData) => {

    state.pageLoader.loaderPreAuthTitle = orderData.loaderTitle;
    state.pageLoader.loaderPreAuthMessage = orderData.loaderMessage;
    SHOW_LOADER(state, {
        'loaderTitle': orderData.getOrderLoaderTitle,
        'loaderMessage': orderData.getOrderLoaderMessage
    });

    state.alertModal.active = true;
    state.context = orderData.context;
    state.orderStored = false;
    state.isNewTeliaCustomer = true;
    state.showTFSummaryInformation = false;
    state.errorMessage = '';
    state.order.orderId = '';
    state.order.useNewDiva = false;
    state.order.manualSigning = false;
    state.order.dealerCode = '';
    state.order.orderGuid = orderData.orderGuid;
    state.order.billingAccountNumber = '';
    state.order.salesAgent = '';
    state.order.channelType = '';
    state.order.modifiableByCustomer = true;
    state.order.orderState = '';
    state.order.orderer = null;
    state.order.existingAgreement = null;
    state.order.agreementOrderItem = null;
    state.order.orderItems = null;
    state.creditAgreement.totalCredit = 0;
    state.creditAgreement.totalPerMonth = 0;
    state.creditAgreement.subscriptionAgreementItems = [];
    state.creditAgreement.payNow = 0;
}

export const STORE_ORDER = (state, order, error) => {
    state.order.orderId = order.orderId;
    state.order.orderGuid = order.orderGuid;
    state.order.dealerCode = order.dealerCode;
    state.order.salesAgent = order.salesAgent;
    state.order.channelType = order.channelType;
    state.order.useNewDiva = order.useNewDiva;
    state.order.manualSigning = order.manualSigning !== null ? order.manualSigning : false;
    switch (state.order.channelType) {
        case 'INT_STORE':
            state.pageDetails.tangoRedirectUrl = state.pageDetails.tangocourl;
            state.salesChannel = 'Telesales';
            break;
        case 'EXT_STORE':
            state.pageDetails.tangoRedirectUrl = state.pageDetails.tango4durl;
            state.salesChannel = 'PhysicalShop';
            break;
        case 'INT_REMOTE':
            state.pageDetails.tangoRedirectUrl = state.pageDetails.tango4durl;
            state.salesChannel = 'Telesales';
            break;
        case 'EXT_REMOTE':
            state.pageDetails.tangoRedirectUrl = state.pageDetails.tango4durl;
            state.salesChannel = 'Telesales';
            break;
        case 'EXT_WEB':
        case 'INT_WEB':
            state.salesChannel = 'WebShop';
            break;
    }
    if (order && order.orderState === 'SUBMITTED') {
        state.order.orderState = order.orderState;
        if (order.billingAccountNumber != null) {
            state.order.billingAccountNumber = order.billingAccountNumber;
        }
        state.order.modifiableByCustomer = order.extendedStatus.modifiableByCustomer;
        state.order.orderer = order.orderer;

        state.contracts.signatureOwnerFullName = order.orderer.person.name.firstName + ' ' + order.orderer.person.name.lastName;

        state.showTFSummaryInformation = false;
        if (order.accountOrderItem.length === 0) {
            state.order.existingAgreement = true;
            state.order.orderItems = order.subscriptionOrderItem;
            state.isNewTeliaCustomer = false;
            if (order.agreementOrderItem != null) {
                state.order.agreementOrderItem = order.agreementOrderItem.agreementCode;
            }
        }
        else {
            state.order.orderItems = [];
            state.isNewTeliaCustomer = true;
            state.order.accountOrderItem.invoiceReceiver = order.accountOrderItem[0].invoiceReceiver;
            state.order.accountOrderItem.legalResponsibleEmail = order.accountOrderItem[0].legalResponsibleEmail;
            state.order.accountOrderItem.legalResponsibleTelephone = (order.accountOrderItem[0].legalResponsibleTelephone) ? order.accountOrderItem[0].legalResponsibleTelephone.localNumber : '';

            state.order.accountOrderItem.billConfiguration = order.accountOrderItem[0].billConfiguration;
            state.order.accountOrderItem.billingAccountNumber = order.accountOrderItem[0].billingAccountNumber;
            state.order.accountOrderItem.fees = order.accountOrderItem[0].fees;
            if (order.agreementOrderItem != null) {
                state.order.agreementOrderItem = order.agreementOrderItem.agreementCode;
            }
            state.contracts.customerEmail = order.accountOrderItem[0].legalResponsibleEmail;

            for (let i = 0; i < order.accountOrderItem[0].subscriptions.length; i++) {
                state.order.orderItems.push(order.accountOrderItem[0].subscriptions[i]);
            }
        }

        //------------------- SETTING PRESET DATA ------------------------------------------//
        let pbsParameters = null;
        if (order.externalPayment && order.externalPayment.billingConfiguration) {
            pbsParameters = order.externalPayment.billingConfiguration.paymentMethod.parameter;
            state.pbsInformation.newTFCustomer = true;
        }
        else if (order.accountOrderItem.length > 0 && order.accountOrderItem[0].billConfiguration) {
            pbsParameters = order.accountOrderItem[0].billConfiguration.paymentMethod.parameter;
        }

        if (pbsParameters) {
            pbsParameters.forEach(function (item, index) {
                switch (item.name) {
                    case 'BANK':
                        state.pbsInformation.bankName = item.value;
                        break;
                    case 'BANK_BRANCH':
                        state.pbsInformation.regNumber = item.value;
                        break;
                    case 'BANK_ACCOUNT_NUMBER':
                        state.pbsInformation.accountNumber = item.value;
                        break;
                }
            });
        }

        // --- RESOLVING PAYMENT METHOD ---
        let paymentMethod = '';

        if (order.accountOrderItem.length > 0 &&
            order.accountOrderItem[0].billConfiguration &&
            order.accountOrderItem[0].billConfiguration.paymentMethod &&
            order.accountOrderItem[0].billConfiguration.paymentMethod.name) {
            paymentMethod = order.accountOrderItem[0].billConfiguration.paymentMethod.name.toLowerCase();
        }
        else if (order.externalPayment &&
            order.externalPayment.billingConfiguration &&
            order.externalPayment.billingConfiguration.paymentMethod &&
            order.externalPayment.billingConfiguration.paymentMethod.name) {
            paymentMethod = order.externalPayment.billingConfiguration.paymentMethod.name.toLowerCase();
        }
        else if (order.evaluationDetails && order.evaluationDetails.payment) {
            paymentMethod = order.evaluationDetails.payment.toLowerCase();
        }

        // if paymentMethod from OM response is 'cc', then store it as 'creditCard;
        state.paymentMethod = paymentMethod === 'cc' ? 'creditCard' : paymentMethod;

        if (order.creditCheckDetails && order.creditCheckDetails.externalCreditCheck) {
            state.order.creditCheckDetails.externalCreditCheck.customerStatus = order.creditCheckDetails.externalCreditCheck.customerStatus;

            if (order.creditCheckDetails.externalCreditCheck.result.decision) {
                state.creditEvaluation.creditCheckResult.creditCheckRef = order.creditCheckDetails.externalCreditCheck.result.reference;

                if (order.creditCheckDetails.externalCreditCheck.result.approvedCreditLimit) {
                    state.creditEvaluation.creditCheckResult.approvedCreditLimit.amount = order.creditCheckDetails.externalCreditCheck.result.approvedCreditLimit.amount;
                    state.creditEvaluation.creditCheckResult.approvedCreditLimit.VAT = order.creditCheckDetails.externalCreditCheck.result.approvedCreditLimit.vat;
                    state.creditEvaluation.creditCheckResult.approvedCreditLimit.currency = order.creditCheckDetails.externalCreditCheck.result.approvedCreditLimit.currency;
                }

                if (order.creditCheckDetails.externalCreditCheck.newCreditLimit) {
                    state.creditEvaluation.creditCheckResult.requestedCreditLimit = order.creditCheckDetails.externalCreditCheck.newCreditLimit.amount
                }

                if (order.creditCheckDetails.externalCreditCheck.result.decision === "OK" &&
                    order.creditCheckDetails.externalCreditCheck.result.approvedCreditLimit &&
                    order.creditCheckDetails.externalCreditCheck.result.approvedCreditLimit.amount > 0) {
                    state.creditEvaluation.creditCheckResult.showDecision = true;
                    state.creditEvaluation.creditCheckResult.approved = true;
                }

                if (state.creditEvaluation.creditCheckResult.requestedCreditLimit > state.creditEvaluation.creditCheckResult.approvedCreditLimit.amount) {
                    state.creditEvaluation.approvedWithLowerLimit = state.creditEvaluation.creditCheckResult.approvedCreditLimit.amount;
                }
                else if (order.creditCheckDetails.externalCreditCheck.result.decision === "REJECTED") {
                    state.creditEvaluation.creditCheckResult.showDecision = true;
                    state.creditEvaluation.creditCheckResult.approved = false;
                }
            }
        }

        for (let i = 0; i < order.contractQuestions.length; i++) {
            if (order.contractQuestions[i].question === "TF_CREDIT_ACCOUNT_PAYMENT") {
                state.customerWantsCreditAgreement = order.contractQuestions[i].answer;
            }
        }

        // Populate ESIM flag for notification
        state.order.orderItems.forEach(orderItem => {
            orderItem.hasEsim = orderItem.hardwareItems.some(hardwareItem => hardwareItem.simType === 'ESIM');
        });

        let totalPrice = 0;
        let totalVatAmmount = 0;
        let subscriptionAgreementItems = [];

        for (let i = 0; i < state.order.orderItems.length; i++) {
            let hardwareItemsPerSubscription = [];

            let subscriptionAgreementItem = null; // Declare the item here

            if (state.order.orderItems[i].hardwareItems.length > 0) {
                const filteredHardwareItems = state.order.orderItems[i].hardwareItems.filter(item => item.equipmentType !== 'SIM' &&
                    state.constants.returnLabelMaterialIds != null &&
                    !state.constants.returnLabelMaterialIds.includes(item.materialId)); // Return an array

                state.order.orderItems[i].hardwareItems = filteredHardwareItems;

                if (filteredHardwareItems !== null &&
                    filteredHardwareItems !== 'undefined' &&
                    filteredHardwareItems.length > 0) {
                    subscriptionAgreementItem = new Object(); // If there are any hardware items which can be displayed/sold on CA, then init the subscriptionAgreementItem
                    subscriptionAgreementItem.discounts = {}; // Init discounts
                    state.order.orderItems[i].hardwareItems = filteredHardwareItems;

                    // Iterate hardware items for current subscription an generate new structure
                    for (let h = 0; h < state.order.orderItems[i].hardwareItems.length; h++) {
                        let itemDiscountAmount = state.order.orderItems[i].hardwareItems[h].discount != null ?
                            state.order.orderItems[i].hardwareItems[h].discount.amount :
                            0;
                        let itemDiscountVAT = state.order.orderItems[i].hardwareItems[h].discount != null ?
                            state.order.orderItems[i].hardwareItems[h].discount.vat :
                            0;
                        let hardwareItemId = state.order.orderItems[i].hardwareItems[h].hardwareItemId
                        let hardwareItemIdKey = "" + hardwareItemId;

                        let hardwareInfoItem = {
                            hardwareItemId: hardwareItemId, // Unique PK from DB
                            materialId: state.order.orderItems[i].hardwareItems[h].materialId,
                            equipmentName: state.order.orderItems[i].hardwareItems[h].equipmentName,
                            equipmentType: state.order.orderItems[i].hardwareItems[h].equipmentType,
                            equipmentBrand: state.order.orderItems[i].hardwareItems[h].equipmentBrand,
                            price: state.order.orderItems[i].hardwareItems[h].price.amount,
                            discount: itemDiscountAmount
                        }

                        // Set subscription down payment configuration
                        subscriptionAgreementItem.id = state.order.orderItems[i].id, // Subscription ID
                            subscriptionAgreementItem.phoneNumber = state.order.orderItems[i].telephoneNumber.localNumber;
                        subscriptionAgreementItem.monthlyPayment = 0;
                        subscriptionAgreementItem.numberOfInstallments = 0;
                        subscriptionAgreementItem.lastInstallment = 0;
                        subscriptionAgreementItem.paymentBy = 'cash';
                        subscriptionAgreementItem.paymentType = (state.order.orderItems[i].hardwarePayment) ? state.order.orderItems[i].hardwarePayment.paymentType : 'EXTERNAL';
                        subscriptionAgreementItem.upfrontPayment = getTotalHardwarePrice(state.order.orderItems[i]); // Upfront price = total price by default
                        subscriptionAgreementItem.hardwarePaymentId = 0;

                        if (itemDiscountAmount > 0) {
                            subscriptionAgreementItem.discounts[hardwareItemIdKey] = {
                                'currency': 'DKK',
                                'amount': itemDiscountAmount,
                                'VAT': itemDiscountVAT
                            }
                        }

                        if (state.order.orderItems[i].hardwarePayment &&
                            state.order.orderItems[i].hardwarePayment.downPayment) {
                            subscriptionAgreementItem.hardwarePaymentId = Number(state.order.orderItems[i].hardwarePayment.hardwarePaymentId);
                            subscriptionAgreementItem.upfrontPayment = Number(state.order.orderItems[i].hardwarePayment.upFrontPayment.amount);
                            subscriptionAgreementItem.numberOfInstallments = Number(state.order.orderItems[i].hardwarePayment.downPayment.numberOfInstallments);
                            subscriptionAgreementItem.monthlyPayment = Number(state.order.orderItems[i].hardwarePayment.downPayment.installmentAmount.amount);
                            subscriptionAgreementItem.lastInstallment = Number(state.order.orderItems[i].hardwarePayment.downPayment.lastInstallmentAmount.amount);

                            if (subscriptionAgreementItem.upfrontPayment != (hardwareInfoItem.price - hardwareInfoItem.discount)) {
                                subscriptionAgreementItem.paymentBy = 'credit';
                            }
                            else {
                                subscriptionAgreementItem.paymentBy = 'cash';
                            }

                            subscriptionAgreementItem.externalTransactionId = state.order.orderItems[i].hardwarePayment.downPayment.externalTransactionId;
                            state.showTFSummaryInformation = true;
                        }

                        hardwareItemsPerSubscription.push(hardwareInfoItem);

                        totalPrice += getTotalHardwarePrice(state.order.orderItems[i]);
                        totalVatAmmount += getTotalVATAmount(state.order.orderItems[i]);
                    }

                    HIDE_LOADER(state);
                }
            }

            if (subscriptionAgreementItem !== null) { // If the subscriptionAgreementItem has been configured above
                // Set HW items per subscription
                subscriptionAgreementItem.hardwareItems = hardwareItemsPerSubscription;

                // Store subscription item in collection - to be displayed in payment configuration and overview sections
                subscriptionAgreementItems.push(subscriptionAgreementItem);
            }
        }

        state.creditAgreement.subscriptionAgreementItems = subscriptionAgreementItems;
        state.order.totalPrice = totalPrice;
        state.order.totalVatAmmount = totalVatAmmount;

        for (let item = 0; item < state.creditAgreement.subscriptionAgreementItems.length; item++) {
            state.order.discount += getTotalDiscountPerSubscription(state.creditAgreement.subscriptionAgreementItems[item]);
        }

        if (!state.order.useNewDiva) {
            UPDATE_CREDIT_AGREEMENT_OVERVIEW_TOTALS(state);
        }
        else {
            UPDATE_CREDIT_AGREEMENT_OVERVIEW_TOTALS_BY_ORDER(state);
            setPaymentDetailsByOrder(state);
        }

        state.orderStored = true;

        if (state.pageDetails.isPaymentPage && !state.order.modifiableByCustomer) {
            window.location.replace(state.pageDetails.summaryUrl + "?guid=" + state.order.orderGuid);
        }

        let availableAmount = 0;
        let currentCreditLimit = 0;
        if (order.creditCheckDetails.externalCreditCheck) {
            if (order.creditCheckDetails.externalCreditCheck.availableAmount) {
                availableAmount = order.creditCheckDetails.externalCreditCheck.availableAmount.amount;
            }
            if (order.creditCheckDetails.externalCreditCheck.currentCreditLimit) {
                currentCreditLimit = order.creditCheckDetails.externalCreditCheck.currentCreditLimit.amount;
            }
        }

        if (order.hardwareDelivery) {
            state.order.hardwareDelivery = order.hardwareDelivery;
        }

        if (!state.order.useNewDiva) {
            if (state.context === 'summary' && state.showTFSummaryInformation && state.creditAgreement.totalCredit > availableAmount) {
                if (!order.creditCheckDetails.externalCreditCheck.newCreditLimit ||
                    order.creditCheckDetails.externalCreditCheck.newCreditLimit.amount > state.creditEvaluation.creditCheckResult.approvedCreditLimit.amount) {
                    SHOW_MODAL(state, { 'context': 'orderState', 'errorState': true, 'icon': 'info', 'showHeadline': false, 'messageContent': ['INVALID CREDIT SELECTION'], 'buttons': ['returnToTango'] });
                } else {
                    state.preAuth.availableAmount = availableAmount;
                    state.preAuth.creditLimit = currentCreditLimit;
                    const selectedCreditLimit = order.creditCheckDetails.externalCreditCheck.newCreditLimit.amount;
                    const totalCredit = state.creditAgreement.totalCredit;
                    if (totalCredit > selectedCreditLimit + state.preAuth.availableAmount - state.preAuth.creditLimit) {
                        SHOW_MODAL(state, { 'context': 'orderState', 'errorState': true, 'icon': 'info', 'showHeadline': false, 'messageContent': ['INVALID CREDIT SELECTION'], 'buttons': ['returnToTango'] });
                    }
                }
            }
        }
    }

    else {
        SHOW_MODAL(state, { 'context': 'orderState', 'errorState': true, 'icon': 'info', 'showHeadline': false, 'messageContent': [order.orderState], 'buttons': ['returnToTango'] });
    }
}

function getTotalHardwarePrice(subscription) {
    let hwItems = subscription.hardwareItems;
    let sum = 0;

    for (let i = 0; i < hwItems.length; i++) {
        let discount = hwItems[i].discount != null ?
            hwItems[i].discount.amount :
            0;

        sum += hwItems[i].price.amount - discount;
    }

    return sum;
}

function getTotalVATAmount(subscription) {
    let hwItems = subscription.hardwareItems;
    let sum = 0;

    for (let i = 0; i < hwItems.length; i++) {
        if (hwItems[i].discount === null) {
            continue;
        }

        sum += hwItems[i].price.vat - hwItems[i].discount.vat;
    }

    return sum;
}

export const STORE_PRICE_PLAN_NAME = (state, data) => {
    if (state.order.orderItems) {
        for (let i = 0; i < state.order.orderItems.length; i++) {
            if (state.order.orderItems[i].id === data.SubscriptionId) {
                state.order.orderItems[i].offeringCode = data.Name;
            }
        }
    }
}

export const STORE_ADDITIONAL_PRODUCT_NAME = (state, data) => {
    if (state.order.orderItems) {
        for (let i = 0; i < state.order.orderItems.length; i++) {
            if (state.order.orderItems[i].id === data.SubscriptionId && state.order.orderItems[i].additionalProducts && state.order.orderItems[i].additionalProducts.additionalProduct.length > 0) {
                for (let j = 0; j < state.order.orderItems[i].additionalProducts.additionalProduct.length; j++) {
                    if (state.order.orderItems[i].additionalProducts.additionalProduct[j].productCode === data.OfferingCode) {
                        state.order.orderItems[i].additionalProducts.additionalProduct[j].productCode = data.Name;
                        break;
                    }
                }
            }
        }
    }
}
export const STORE_INCLUDED_ADDITIONAL_PRODUCT_NAME = (state, data) => {
    if (state.order.orderItems) {
        for (let i = 0; i < state.order.orderItems.length; i++) {
            if (state.order.orderItems[i].id === data.SubscriptionId && state.order.orderItems[i].additionalProducts && state.order.orderItems[i].additionalProducts.includedAdditionalProduct.length > 0) {
                for (let j = 0; j < state.order.orderItems[i].additionalProducts.includedAdditionalProduct.length; j++) {
                    if (state.order.orderItems[i].additionalProducts.includedAdditionalProduct[j] === data.OfferingCode) {
                        state.order.orderItems[i].additionalProducts.includedAdditionalProduct[j] = data.Name;
                        break;
                    }
                }
            }
        }
    }
}
export const STORE_LOST_ADDITIONAL_PRODUCT_NAME = (state, data) => {
    if (state.order.orderItems) {
        for (let i = 0; i < state.order.orderItems.length; i++) {
            if (state.order.orderItems[i].id === data.SubscriptionId && state.order.orderItems[i].additionalProducts && state.order.orderItems[i].additionalProducts.lostAdditionalProduct.length > 0) {
                for (let j = 0; j < state.order.orderItems[i].additionalProducts.lostAdditionalProduct.length; j++) {
                    if (state.order.orderItems[i].additionalProducts.lostAdditionalProduct[j] === data.OfferingCode) {
                        state.order.orderItems[i].additionalProducts.lostAdditionalProduct[j] = data.Name;
                        break;
                    }
                }
            }
        }
    }
}

export const STORE_DIRECTORY_LISTING_TEXT = (state, data) => {
    if (state.order.orderItems) {
        for (let i = 0; i < state.order.orderItems.length; i++) {
            if (state.order.orderItems[i].id === data.SubscriptionId) {
                state.order.orderItems[i].directoryListingLevel = (data.Text != "null") ? data.Text : '';
            }
        }
    }
}

export const STORE_CONSENT_TITLES = (state, data) => {
    if (state.order.orderItems) {
        for (let i = 0; i < state.order.orderItems.length; i++) {
            if (state.order.orderItems[i].id === data.SubscriptionId &&
                state.order.orderItems[i].customerConsents != 'undefined' &&
                state.order.orderItems[i].customerConsents != null &&
                state.order.orderItems[i].customerConsents.length > 0) {

                for (let j = 0; j < state.order.orderItems[i].customerConsents.length; j++) {
                    if (state.order.orderItems[i].customerConsents[j].consentId === data.ConsentId) {
                        Vue.set(state.order.orderItems[i].customerConsents[j], 'title', data.Title);
                        Vue.set(state.order.orderItems[i].customerConsents[j], 'rank', data.Rank);
                        break;
                    }
                }
            }
        }
    }
}

export const STORE_ORDER_UPDATES = (state, orderUpdates) => {
    state.orderUpdates = orderUpdates;
}

export const ORDER_SUBMITTED = (state, submitOrderData) => {
    const submitStatus = JSON.parse(submitOrderData);

    if (submitStatus.IsInErrorState) {
        HIDE_LOADER(state);

        if (submitStatus.SubmitState === 1) {
            SHOW_MODAL(state, { 'context': 'submitOrderState1', 'errorState': false, 'icon': 'warning', 'showHeadline': false, 'messageContent': [submitStatus.Message], 'buttons': ['resubmit', 'refresh'] });
        } else {
            SHOW_MODAL(state, { 'context': 'submitOrderState2', 'errorState': false, 'icon': 'info', 'showHeadline': false, 'messageContent': [], 'buttons': ['returnToTango'] });
        }
    } else {
        window.location = state.pageDetails.tangoRedirectUrl + "/Default.aspx?mode=ordering&previousOrderGuid=" + state.order.orderGuid;
    }
}

export const ORDER_SUBMITTED_REMOTE_CHANNEL = (state, orderSubmitForRemoteChannelData) => {
    const submitForRemoteChannelStatus = JSON.parse(orderSubmitForRemoteChannelData);
    if (submitForRemoteChannelStatus.IsInErrorState) {
        HIDE_LOADER(state);
        SHOW_MODAL(state, { 'context': 'submitOrderForRemoteChannel', 'errorState': false, 'icon': 'warning', 'showHeadline': false, 'messageContent': [submitForRemoteChannelStatus.Message], 'buttons': ['resubmit', 'refresh'] });
    }
    else {
        window.location = state.pageDetails.tangoRedirectUrl + "/Default.aspx?mode=ordering&previousOrderGuid=" + state.order.orderGuid;
    }
}

export const CHANGE_CREDIT_AGREEMENT_SELECTED = (state) => {
    state.customerWantsCreditAgreement = !state.customerWantsCreditAgreement;
    if (!state.customerWantsCreditAgreement) {
        RESET_CREDIT_AGREEMENT_OVERVIEW(state);
    }
}

export const SET_SELECTED_CREDIT_INSTALLMENTS = (state, selection) => {
    for (let i = 0; i < state.creditAgreement.subscriptionAgreementItems.length; i++) {
        if (state.creditAgreement.subscriptionAgreementItems[i].id === selection.id) {
            state.creditAgreement.subscriptionAgreementItems[i].numberOfInstallments = selection.installments;
            state.creditAgreement.subscriptionAgreementItems[i].monthlyPayment = Number(selection.monthlyInstallment);
            state.creditAgreement.subscriptionAgreementItems[i].lastInstallment = Number(selection.lastInstallment);
        }
    }

    UPDATE_CREDIT_AGREEMENT_OVERVIEW_TOTALS(state);
}
export const SET_SELECTED_CREDIT_INSTALLMENTS_BY_ORDER = (state, selection) => {

    state.creditAgreement.numberOfInstallments = Number(selection.installments);
    state.creditAgreement.monthlyPayment = Number(selection.monthlyInstallment);
    state.creditAgreement.lastInstallment = Number(selection.lastInstallment);

    UPDATE_CREDIT_AGREEMENT_OVERVIEW_TOTALS_BY_ORDER(state);
}

export const SHOW_LOADER = (state, loaderData) => {
    state.pageLoader.showLoader = true;
    state.pageLoader.loaderTitle = loaderData.loaderTitle;
    state.pageLoader.loaderMessage = loaderData.loaderMessage;
}

export const HIDE_LOADER = (state) => {
    state.pageLoader.showLoader = false;
}

export const IS_CREDIT_CHECK_VALID = (state, value) => {
    state.isCreditCheckValid = value;
}

export const CHANGE_PAYMENT_BY = (state, selection) => {
    SHOW_LOADER(state, selection);

    for (let i = 0; i < state.creditAgreement.subscriptionAgreementItems.length; i++) {
        if (state.creditAgreement.subscriptionAgreementItems[i].id === selection.id) {
            state.creditAgreement.subscriptionAgreementItems[i].paymentBy = selection.type;
            if (selection.type === 'cash') {
                const resetData = {
                    'id': selection.id,
                    'fullReset': "yes"
                };

                RESET_CREDIT_AGREEMENT_ITEM(state, resetData);
            } else {
                const downPaymentPlan = getDownPaymentPlan(state, state.creditAgreement.subscriptionAgreementItems[i]);

                state.creditAgreement.subscriptionAgreementItems[i].upfrontPayment = downPaymentPlan.minUpfrontPayment;

                UPDATE_CREDIT_AGREEMENT_OVERVIEW_TOTALS(state);
            }
            break;
        }
    }
}
export const CHANGE_PAYMENT_BY_ORDER = (state, selection) => {
    SHOW_LOADER(state, selection);

    state.order.paymentBy = selection.type;

    if (selection.type === 'cash') {
        const resetData = {
            'id': selection,
            'fullReset': "yes"
        };

        RESET_CREDIT_AGREEMENT_ITEM_BY_ORDER(state, resetData);
    } else {
        UPDATE_CREDIT_AGREEMENT_OVERVIEW_TOTALS_BY_ORDER(state);
    }
    HIDE_LOADER(state);
}
function getDownPaymentPlan(state, subscriptionAgreement) {
    for (let i = 0; i < state.downPaymentPlan.plans.length; i++) {
        const downPaymentPlanItem = state.downPaymentPlan.plans[i];

        for (let h = 0; h < subscriptionAgreement.hardwareItems.length; h++) {
            let hardwareItem = subscriptionAgreement.hardwareItems[h];

            if (hardwareItem.equipmentType.toUpperCase() === downPaymentPlanItem.hardwareType.toUpperCase() &&
                hardwareItem.equipmentBrand.toUpperCase() === downPaymentPlanItem.hardwareBrand.toUpperCase()) {

                return downPaymentPlanItem;
            }
        }
    }

    return state.downPaymentPlan.plans[0];
}

export const CHANGE_UPFRONT_PAYMENT = (state, selection) => {
    for (let i = 0; i < state.creditAgreement.subscriptionAgreementItems.length; i++) {
        if (state.creditAgreement.subscriptionAgreementItems[i].id === selection.id) {
            state.creditAgreement.subscriptionAgreementItems[i].upfrontPayment = selection.upfrontPayment;
        }
    }

    UPDATE_CREDIT_AGREEMENT_OVERVIEW_TOTALS(state);
}
export const CHANGE_UPFRONT_PAYMENT_BY_ORDER = (state, payload) => {
    state.creditAgreement.upfrontAmount = Number(payload.upfrontAmount);
    state.creditAgreement.monthlyPayment = Number(payload.installmentAmount);
    state.creditAgreement.totalPerMonth = Number(payload.installmentAmount);
    state.creditAgreement.lastInstallment = Number(payload.lastInstallment);
    state.creditAgreement.numberOfInstallments = Number(payload.numberOfInstallments);

    UPDATE_CREDIT_AGREEMENT_OVERVIEW_TOTALS_BY_ORDER(state);
}
export const GET_PREAUTH = (state, loaderData) => {
    state.pageLoader.loaderPreAuthTitle = loaderData.loaderTitle;
    state.pageLoader.loaderPreAuthMessage = loaderData.loaderMessage;

    SHOW_LOADER(state, loaderData);

    state.preAuth.status = '';
    state.preAuth.statusDescription = '';
    state.preAuth.creditLimit = 0;
    state.preAuth.availableAmount = 0;
    state.preAuth.availableCreditLimits = [];
    state.preAuth.preselectedLimit = 0;
}

export const GET_JOICE_CREDITCHECK = (state, loaderData) => {
    state.pageLoader.loaderCreditCheckTitle = loaderData.loaderTitle;
    state.pageLoader.loaderCreditCheckMessage = loaderData.loaderMessage;

    SHOW_LOADER(state, loaderData);

    state.joiceCreditCheck.status = '';
    state.joiceCreditCheck.statusDescription = '';
    state.joiceCreditCheck.CreditAccountCurrentLimit = 0;
    state.joiceCreditCheck.CreditAccountCurrentAvailableAmount = 0;
    state.joiceCreditCheck.creditAccountMaxAvailableAmount = 0;
    state.joiceCreditCheck.maxAvailableAmount = 0;
    state.joiceCreditCheck.errorMessage = '';
}

export const STORE_PREAUTH = (state, preAuth) => {
    state.preAuth.status = preAuth.Return.Status.TransactionStatus;
    state.preAuth.statusDescription = preAuth.Return.Status.TransactionStatusDesc;
    if (state.preAuth.successfulCodes.indexOf(state.preAuth.status) > -1) {
        state.preAuth.creditLimit = preAuth.Return.Response.CreditLimit;
        state.preAuth.availableAmount = preAuth.Return.Response.AvailableAmount;
        state.preAuth.availableCreditLimits = preAuth.Return.Response.AvailableCreditLimits;
        state.preAuth.isSuccessful = true;

        //adding customerStatus here as it might not be set in NEO yet when we do STORE_ORDER
        if (state.preAuth.status === "6") {
            state.order.creditCheckDetails.externalCreditCheck.customerStatus = "NEW";
        }
        else {
            state.order.creditCheckDetails.externalCreditCheck.customerStatus = "EXISTING";
        }
    }
    else {
        state.preAuth.blocked = true;
        state.creditAgreement.subscriptionAgreementItems.forEach(function (item) {
            RESET_CREDIT_AGREEMENT_ITEM(state, { 'id': item.id, 'fullReset': "yes" });//yes, partial, no
        });
        state.showTFSummaryInformation = false;

        if (state.preAuth.blockedCode.indexOf(state.preAuth.status) > -1) {
            SHOW_MODAL(state, { 'context': 'preAuthBlocked', 'errorState': false, 'icon': 'info', 'showHeadline': false, 'messageContent': [], 'buttons': ['cancel', 'closeContinue'] });
        }
        else if (state.preAuth.expiredCode.indexOf(state.preAuth.status) > -1) {
            SHOW_MODAL(state, { 'context': 'preAuthExpired', 'errorState': false, 'icon': 'info', 'showHeadline': false, 'messageContent': [], 'buttons': ['cancel', 'closeContinue'] });
        }
        else {
            SHOW_MODAL(state, { 'context': 'preAuthGeneral', 'errorState': false, 'icon': 'info', 'showHeadline': false, 'messageContent': [], 'buttons': ['cancel', 'refresh'] });
        }
    }

    UPDATE_CREDIT_AGREEMENT_OVERVIEW_TOTALS(state);
    state.preAuth.stored = true;
}

export const STORE_JOICE_CREDITCHECK = (state, joiceCreditCheck) => {
    if (joiceCreditCheck.Result.Status === "APPROVED") {
        const joicedata = {
            status: joiceCreditCheck.Result.Status,
            statusDescription: joiceCreditCheck.Result.StatusReason,
            isSuccessful: true,
            creditAccountCurrentLimit: joiceCreditCheck.Result.CreditAccountCurrentLimit,
            creditAccountCurrentAvailableAmount: joiceCreditCheck.Result.CreditAccountCurrentAvailableAmount,
            creditAccountLimit: joiceCreditCheck.Result.CreditAccountLimit,
            creditAccountMaxAvailableAmount: joiceCreditCheck.Result.CreditAccountMaxAvailableAmount > 0 ?
                joiceCreditCheck.Result.CreditAccountMaxAvailableAmount :
                (joiceCreditCheck.Result.CreditAccountLimit - joiceCreditCheck.Result.CreditAccountCurrentLimit) + Number(joiceCreditCheck.Result.CreditAccountCurrentAvailableAmount),
            stored: true,
            errorMessage: joiceCreditCheck.Result.ErrorMessage
        };
        Object.assign(state.joiceCreditCheck, joicedata);
        if (joiceCreditCheck.Result.TfAccountExists === false) {
            state.order.creditCheckDetails.externalCreditCheck.customerStatus = "NEW";
        }
        else {
            state.order.creditCheckDetails.externalCreditCheck.customerStatus = "EXISTING";
        }
    }
    else {
        if (joiceCreditCheck.Result.Status === "DECLINED" || joiceCreditCheck.Result.Status === "UNDERWRITING") {
            SHOW_MODAL_JOICE_ERROR_HANDLING(state, { 'context': 'joiceOrderRetry', 'errorState': false, 'icon': 'info', 'showHeadline': false, 'messageContent': joiceCreditCheck.Result.ErrorMessage, 'buttons': ['refresh'] });
        }
        else if (joiceCreditCheck.Result.Status === "RETRY") {
            SHOW_MODAL_JOICE_ERROR_HANDLING(state, { 'context': 'joiceOrderRetry', 'errorState': false, 'icon': 'info', 'showHeadline': false, 'messageContent': joiceCreditCheck.Result.ErrorMessage, 'buttons': ['refresh'] });
        }
        else {
            SHOW_MODAL_JOICE_ERROR_HANDLING(state, { 'context': 'joiceOrderRejected', 'errorState': false, 'icon': 'info', 'showHeadline': false, 'messageContent': [], 'buttons': ['cancel', 'refresh'] });
        }

    }
    UPDATE_CREDIT_AGREEMENT_OVERVIEW_TOTALS_BY_ORDER(state);
}

export const SET_CUSTOMER_EMAIL_WARNING = (state, showWarning) => {
    state.contracts.validEmails = !showWarning;
    state.warnings.customerEmail.show = showWarning;
}

export const SET_TEXTS = (state, errorMessages) => {
    if (errorMessages.pbsInfoWarning) {
        state.warnings.pbsInfoWarning.message = errorMessages.pbsInfoWarning;
    }
    if (errorMessages.customerEmail) {
        state.warnings.customerEmail.message = errorMessages.customerEmail;
    }
    if (errorMessages.getOrder) {
        state.modalTexts.getOrder = errorMessages.getOrder;
    }
    if (errorMessages.orderState) {
        state.modalTexts.orderState = errorMessages.orderState;
    }
    if (errorMessages.preAuthBlocked) {
        state.modalTexts.preAuthBlocked = errorMessages.preAuthBlocked;
    }
    if (errorMessages.preAuthExpired) {
        state.modalTexts.preAuthExpired = errorMessages.preAuthExpired;
    }
    if (errorMessages.preAuthData) {
        state.modalTexts.preAuthData = errorMessages.preAuthData;
    }
    if (errorMessages.preAuthGeneral) {
        state.modalTexts.preAuthGeneral = errorMessages.preAuthGeneral;
    }
    if (errorMessages.cancelOrder) {
        state.modalTexts.cancelOrder = errorMessages.cancelOrder;
    }
    if (errorMessages.joiceOrderRejected) {
        state.modalTexts.joiceOrderRejected = errorMessages.joiceOrderRejected;
    }
    if (errorMessages.joiceOrderRetry) {
        state.modalTexts.joiceOrderRetry = errorMessages.joiceOrderRetry;
    }
    if (errorMessages.joiceCreditCheckData) {
        state.modalTexts.joiceCreditCheckData = errorMessages.joiceCreditCheckData;
    }
    if (errorMessages.cancelOrderError) {
        state.modalTexts.cancelOrderError = errorMessages.cancelOrderError;
    }
    if (errorMessages.updateOrder) {
        state.modalTexts.updateOrder = errorMessages.updateOrder;
    }
    if (errorMessages.getOrderUpdates) {
        state.modalTexts.getOrderUpdates = errorMessages.getOrderUpdates;
    }
    if (errorMessages.downPaymentPlan) {
        state.modalTexts.downPaymentPlan = errorMessages.downPaymentPlan;
    }
    if (errorMessages.creditCheck) {
        state.modalTexts.creditCheck = errorMessages.creditCheck;
    }
    if (errorMessages.contracts) {
        state.modalTexts.contracts = errorMessages.contracts;
    }
    if (errorMessages.checkSignature) {
        state.modalTexts.checkSignature = errorMessages.checkSignature;
    }
    if (errorMessages.installmentsNotSet) {
        state.modalTexts.installmentsNotSet = errorMessages.installmentsNotSet;
    }
    if (errorMessages.createExternalPayment) {
        state.modalTexts.createExternalPayment = errorMessages.createExternalPayment;
    }
    if (errorMessages.blockedPopup) {
        state.modalTexts.blockedPopup = errorMessages.blockedPopup;
    }
    if (errorMessages.submitOrder) {
        state.modalTexts.submitOrder = errorMessages.submitOrder;
    }
    if (errorMessages.submitOrderState1) {
        state.modalTexts.submitOrderState1 = errorMessages.submitOrderState1;
    }
    if (errorMessages.submitOrderState2) {
        state.modalTexts.submitOrderState2 = errorMessages.submitOrderState2;
    }
    if (errorMessages.submitOrderForRemoteChannel) {
        state.modalTexts.submitOrderForRemoteChannel = errorMessages.submitOrderForRemoteChannel;
    }
}

export const SET_CONSTANTS = (state, constants) => {
    if (constants.returnLabelMaterialIds) {
        state.constants.returnLabelMaterialIds = constants.returnLabelMaterialIds;
    }
}

export const SET_PAGE_LOADER_TEXTS = (state, loaderTexts) => {

    console.log('SET_PAGE_LOADER_TEXTS');

    // SetCreditCheckNewCreditLimitLoaderTitle
    if (loaderTexts.loaderSetCreditCheckNewCreditLimitLoaderTitle) {
        state.pageLoader.loaderSetCreditCheckNewCreditLimitLoaderTitle = loaderTexts.loaderSetCreditCheckNewCreditLimitLoaderTitle;
    }
    if (loaderTexts.loaderSetCreditCheckNewCreditLimitLoaderMessage) {
        state.pageLoader.loaderSetCreditCheckNewCreditLimitLoaderMessage = loaderTexts.loaderSetCreditCheckNewCreditLimitLoaderMessage;
    }

    // UpdateHardwarePaymentLoaderTitle
    if (loaderTexts.loaderUpdateHardwarePaymentLoaderTitle) {
        state.pageLoader.loaderUpdateHardwarePaymentLoaderTitle = loaderTexts.loaderUpdateHardwarePaymentLoaderTitle;
    }
    if (loaderTexts.loaderUpdateHardwarePaymentLoaderMessage) {
        state.pageLoader.loaderUpdateHardwarePaymentLoaderMessage = loaderTexts.loaderUpdateHardwarePaymentLoaderMessage;
    }

    // ResetCreditCheckNewCreditLimitLoaderTitle
    if (loaderTexts.loaderResetCreditCheckNewCreditLimitLoaderTitle) {
        state.pageLoader.loaderResetCreditCheckNewCreditLimitLoaderTitle = loaderTexts.loaderResetCreditCheckNewCreditLimitLoaderTitle;
    }
    if (loaderTexts.loaderResetCreditCheckNewCreditLimitLoaderMessage) {
        state.pageLoader.loaderResetCreditCheckNewCreditLimitLoaderMessage = loaderTexts.loaderResetCreditCheckNewCreditLimitLoaderMessage;
    }

    // GoToSummaryLoaderTitle
    if (loaderTexts.loaderGoToSummaryLoaderTitle) {
        state.pageLoader.loaderGoToSummaryLoaderTitle = loaderTexts.loaderGoToSummaryLoaderTitle;
    }
    if (loaderTexts.loaderGoToSummaryLoaderMessage) {
        state.pageLoader.loaderGoToSummaryLoaderMessage = loaderTexts.loaderGoToSummaryLoaderMessage;
    }

    // GoToPaymentSelectionLoaderTitle
    if (loaderTexts.loaderGoToPaymentSelectionLoaderTitle) {
        state.pageLoader.loaderGoToPaymentSelectionLoaderTitle = loaderTexts.loaderGoToPaymentSelectionLoaderTitle;
    }
    if (loaderTexts.loaderGoToPaymentSelectionLoaderMessage) {
        state.pageLoader.loaderGoToPaymentSelectionLoaderMessage = loaderTexts.loaderGoToPaymentSelectionLoaderMessage;
    }

    // GoToTangoLoaderTitle
    if (loaderTexts.loaderGoToTangoLoaderTitle) {
        state.pageLoader.loaderGoToTangoLoaderTitle = loaderTexts.loaderGoToTangoLoaderTitle;
    }
    if (loaderTexts.loaderGoToTangoLoaderMessage) {
        state.pageLoader.loaderGoToTangoLoaderMessage = loaderTexts.loaderGoToTangoLoaderMessage;
    }
}

export const SET_BUTTON_TEXTS = (state, texts) => {
    if (texts.close) { state.buttonTexts.close = texts.close; }
    if (texts.closeContinue) { state.buttonTexts.closeContinue = texts.closeContinue; }
    if (texts.refresh) { state.buttonTexts.refresh = texts.refresh; }
    if (texts.cancel) { state.buttonTexts.cancel = texts.cancel; }
    if (texts.retryCreditCheck) { state.buttonTexts.retryCreditCheck = texts.retryCreditCheck; }
    if (texts.retryPreAuth) { state.buttonTexts.retryPreAuth = texts.retryPreAuth; }
    if (texts.retryJoiceCreditCheck) { state.buttonTexts.retryJoiceCreditCheck = texts.retryJoiceCreditCheck; }
    if (texts.resubmit) { state.buttonTexts.resubmit = texts.resubmit; }
    if (texts.submit) { state.buttonTexts.submit = texts.submit; }
    if (texts.returnToTango) { state.buttonTexts.returnToTango = texts.returnToTango; }
}
export const SHOW_MODAL_JOICE_ERROR_HANDLING = (state, data) => {
    HIDE_LOADER(state);
    state.inErrorState = data.errorState;
    state.alertModal.context = data.context;
    state.alertModal.message = data.messageContent;
    if (data.showHeadline) {
        state.alertModal.headline = state.modalTexts[data.context + 'Headline'];
    }
    state.alertModal.buttons = data.buttons;
    state.alertModal.icon = data.icon;
    state.alertModal.show = true;
}
export const SHOW_MODAL = (state, data) => {
    HIDE_LOADER(state);
    state.creditEvaluation.creditCheckResult.showDecision = false;
    state.inErrorState = data.errorState;
    state.alertModal.context = data.context;
    if (data.showHeadline) {
        state.alertModal.headline = state.modalTexts[data.context + 'Headline'];
    }
    else {
        state.alertModal.headline = "";
    }
    state.alertModal.message = state.modalTexts[data.context];
    data.messageContent.forEach(function (item, index) {
        state.alertModal.message = state.alertModal.message.replace("{" + index + "}", item);
    });
    state.alertModal.buttons = data.buttons;
    state.alertModal.icon = data.icon;
    state.alertModal.show = true;
}

export const SHOW_MODAL_MANUAL_SIGNING = (state, texts) => {
    state.alertModal.show = true;
    state.alertModal.context = 'signing';
    state.alertModal.icon = 'pebble';
    state.alertModal.message = texts.message;
    state.alertModal.headline = texts.headline;
    state.alertModal.buttons = ['submit', 'close'];
    state.alertModal.signLoaderTitle = texts.signLoaderTitle;
    state.alertModal.signLoaderMessage = texts.signLoaderMessage;
}

export const SHOW_MODAL_REPEAT_SIGNING = (state, texts) => {
    HIDE_LOADER(state);
    state.alertModal.show = true;
    state.alertModal.context = 'signing';
    state.alertModal.icon = 'warning';
    state.alertModal.message = texts.message;
    state.alertModal.headline = texts.headline;
    state.alertModal.buttons = ['submit', 'close'];
    state.alertModal.signLoaderTitle = texts.signLoaderTitle;
    state.alertModal.signLoaderMessage = texts.signLoaderMessage;
}

export const SHOW_MODAL_REPEAT_SIGNING_BY_NAME = (state, texts) => {
    HIDE_LOADER(state);

    state.contracts.signingError.message = 'There was an error while signing please try again.';
    state.contracts.signingError.show = true;
}

export const HIDE_POPUP_MESSAGE = (state, texts) => {
    state.contracts.signingError.message = '';
    state.contracts.signingError.show = false;
}

export const SHOW_MODAL_DIGITAL_SIGNING = (state, texts) => {
    state.alertModal.show = true;
    state.alertModal.context = 'signingDigital';
    state.alertModal.icon = 'pebble';
    state.alertModal.message = texts.message;
    state.alertModal.headline = texts.headline;
    state.alertModal.buttons = ['close'];
    state.alertModal.signLoaderTitle = texts.signLoaderTitle;
    state.alertModal.signLoaderMessage = texts.signLoaderMessage;
    state.alertModal.digitalSignatureLabels = texts.digitalSignatureLabels;
}

export const HIDE_MODAL = (state) => {
    state.alertModal.show = false;
    state.alertModal.message = '';
    state.alertModal.headline = '';
    state.alertModal.context = '';
    state.alertModal.buttons = [];
    state.alertModal.icon = 'default';
}

export const DEACTIVATE_MODAL = (state) => {
    state.alertModal.active = false;
}

export const STORE_DOWN_PAYMENT_PLAN = (state, downPaymentPlan) => {
    state.downPaymentPlan.plans = [];
    downPaymentPlan.forEach(function (item) {
        let downPaymentPlan = {
            id: item.Id,
            hardwareBrand: item.HardwareBrand,
            hardwareType: item.HardwareType,
            allowedPaymentMethods: item.AllowedPaymentMethods,
            minInstallmentAmount: item.MinInstallmentAmount,
            minUpfrontPayment: item.MinUpfrontPayment,
            minNumberOfInstallments: item.MinNumberOfInstallments,
            maxNumberOfInstallments: item.MaxNumberOfInstallments,
            installmentStepAmount: item.InstallmentStepAmount,
            minTotalPayment: item.MinTotalPayment,
            agreementType: item.AgreementType,
            agreementSubType: item.AgreementSubType,
            allowedInstalments: item.AllowedInstalments
        };
        state.downPaymentPlan.plans.push(downPaymentPlan);
    });

    state.downPaymentPlan.stored = true;
    HIDE_LOADER(state);
}

export const STORE_DISCOUNT_DETAILS = (state, discountsData) => {
    const discount = JSON.parse(discountsData);

    if (discount.DiscountState === 0) {
        state.discounts.showDiscounts = false;
        state.discounts.discountType = "NoDiscount";
    }
    else if (discount.DiscountState === 1) {
        state.discounts.showDiscounts = true;
        state.discounts.discountType = "PayNowOnly";
    }
    else if (discount.DiscountState === 2) {
        state.discounts.showDiscounts = true;
        state.discounts.discountType = "CaIncluded";
    }
    else {
        state.discounts.showDiscounts = false;
        state.discounts.discountType = "NoDiscount";
    }
}

export const SET_DISCOUNT = (state, data) => {
    var hardwareItemIdKey = "" + data.hardwareItemId;

    data.hardwareItem.discount = (data.discount != null) ? data.discount.amount : 0;

    if (data.discount !== null) {
        data.selectedCreditAgreementItem.discounts[hardwareItemIdKey] = data.discount;
    } else {
        data.selectedCreditAgreementItem.discounts[hardwareItemIdKey] = null; // Error
    }
}

export const SET_DISCOUNT_BY_ORDER = (state, data) => {
    state.order.discount = data.discount.amount;
}

export const STORE_HARDWARE_PAYMENT = (state, hardwarePayment) => {
    var hardwarePaymentObj = JSON.parse(hardwarePayment);
    for (let i = 0; i < state.creditAgreement.subscriptionAgreementItems.length; i++) {
        if (state.creditAgreement.subscriptionAgreementItems[i].id === hardwarePaymentObj.subscriptionId) {
            state.creditAgreement.subscriptionAgreementItems[i].hardwarePaymentId = hardwarePaymentObj.hardwarePaymentId;
            break;
        }
    }

    HIDE_LOADER(state);
}

export const GET_UPDATE_HARDWARE_PAYMENT = (state, loaderData) => {
    SHOW_LOADER(state, loaderData);
}

export const STORE_UPDATE_HARDWARE_PAYMENT = (state, hardwarePayment) => {
    //console.log(hardwarePayment)
    HIDE_LOADER(state);
}

export const DELETE_HARDWARE_PAYMENT = (state, subscriptionId) => {
    for (let i = 0; i < state.creditAgreement.subscriptionAgreementItems.length; i++) {
        if (state.creditAgreement.subscriptionAgreementItems[i].id === subscriptionId) {
            state.creditAgreement.subscriptionAgreementItems[i].hardwarePaymentId = 0;
            break;
        }
    }

    HIDE_LOADER(state);
}

export const GET_SELECTED_CREDIT_LIMIT = (state, loaderData) => {
    SHOW_LOADER(state, loaderData);
}

export const STORE_SELECTED_CREDIT_LIMIT = (state, creditLimit) => {
    creditLimit = JSON.parse(creditLimit);
    state.creditEvaluation.selectedCreditLimit = Number(creditLimit.Amount);
    if (creditLimit.Amount > state.creditEvaluation.creditCheckResult.approvedCreditLimit.amount) {
        state.creditEvaluation.creditCheckResult.approved = false;
        state.creditEvaluation.initState = false;
        state.creditEvaluation.creditCheckResult.showDecision = false;
    }
    else {
        state.creditEvaluation.creditCheckResult.approved = true;
        state.creditEvaluation.creditCheckResult.showDecision = true;
    }

    HIDE_LOADER(state);
}

export const GET_RESET_CREDIT_LIMIT = (state, loaderData) => {
    SHOW_LOADER(state, loaderData);
}

export const RESET_CREDIT_LIMIT = (state, redirectUrl) => {
    state.creditEvaluation.selectedCreditLimit = null;
    state.creditEvaluation.creditCheckResult.approved = false;
    window.location = redirectUrl;

    HIDE_LOADER(state);
}

export const UPDATE_PBS_INFORMATION = (state, pbsData) => {
    switch (pbsData.field) {
        case 'bankName':
            state.pbsInformation.bankName = pbsData.value;
            break;
        case 'regno':
            state.pbsInformation.regNumber = pbsData.value;
            break;
        case 'accountno':
            state.pbsInformation.accountNumber = pbsData.value;
            break;
    }
}

export const SET_PBS_ERROR = (state, validationStatus) => {
    state.warnings.pbsInfoWarning.show = !validationStatus.valid;
    state.warnings.pbsInfoWarning.message = validationStatus.message;
}

export const GET_CREATE_EXTERNAL_PAYMENT = (state, loaderData) => {
    SHOW_LOADER(state, loaderData);
}

export const SET_CREATE_EXTERNAL_PAYMENT = (state, createExternalPaymentData) => {
    if (createExternalPaymentData.status.IsInErrorState) {
        HIDE_LOADER(state);
        state.alertModal.active = true;
        SHOW_MODAL(state, { 'context': 'createExternalPayment', 'errorState': false, 'icon': 'warning', 'showHeadline': false, 'messageContent': [createExternalPaymentData.status.Message], 'buttons': ['closeContinue'] });
    }
    else {
        window.location = createExternalPaymentData.redirectUrl;
    }
}

export const GET_CREDIT_CHECK_RESULT = (state, loaderData) => {
    state.pageLoader.showLoader = true;
    state.pageLoader.loaderTitle = loaderData.loaderTitle;
    state.pageLoader.loaderMessage = loaderData.loaderMessage;
    state.pageLoader.loaderCreditCheckTitle = loaderData.loaderTitle;
    state.pageLoader.loaderCreditCheckMessage = loaderData.loaderMessage;
    state.creditEvaluation.creditCheckResult.requestedCreditLimit = loaderData.requestedLimit;
    state.creditEvaluation.approvedWithLowerLimit = 0;
}

export const STORE_CREDIT_CHECK_RESULT = (state, externalCreditCheckResult) => {
    var externalCreditCheckResultObject = JSON.parse(externalCreditCheckResult);
    let joiceParameters = null;

    if (externalCreditCheckResultObject.Decision === "OK") {
        const approvedCreditLimitAmount = Number(externalCreditCheckResultObject.ApprovedCreditLimit.Amount);
        state.creditEvaluation.creditCheckResult.approvedCreditLimit.VAT = externalCreditCheckResultObject.ApprovedCreditLimit.VAT;
        state.creditEvaluation.creditCheckResult.approvedCreditLimit.amount = approvedCreditLimitAmount;
        state.creditEvaluation.creditCheckResult.approvedCreditLimit.currency = externalCreditCheckResultObject.ApprovedCreditLimit.Currency;
        state.creditEvaluation.creditCheckResult.code = externalCreditCheckResultObject.Code;
        state.creditEvaluation.creditCheckResult.creditTerms = externalCreditCheckResultObject.CreditTerms;
        state.creditEvaluation.creditCheckResult.statusCode = externalCreditCheckResultObject.StatusCode;
        state.creditEvaluation.creditCheckResult.creditCheckRef = externalCreditCheckResultObject.Reference;
        state.creditEvaluation.creditCheckResult.approved = true;

        joiceParameters = externalCreditCheckResultObject.CreditTerms;

        if (state.creditEvaluation.creditCheckResult.approvedCreditLimit.amount !== state.creditEvaluation.selectedCreditLimit) {
            state.creditEvaluation.approvedWithLowerLimit = state.creditEvaluation.creditCheckResult.approvedCreditLimit.amount;
            state.creditEvaluation.selectedCreditLimit = state.creditEvaluation.creditCheckResult.approvedCreditLimit.amount;
        }
        if (!state.order.useNewDiva) {
            if (state.preAuth.availableCreditLimits.indexOf(approvedCreditLimitAmount) === -1) {
                state.creditEvaluation.creditCheckResult.approved = false;
            }
        }
        else {
            if (state.joiceCreditCheck.creditAccountMaxAvailableAmount.indexOf(approvedCreditLimitAmount) === -1) {
                state.creditEvaluation.creditCheckResult.approved = false;
            }
        }

    }
    else {
        state.creditEvaluation.creditCheckResult.creditTerms = externalCreditCheckResultObject.CreditTerms;
        joiceParameters = externalCreditCheckResultObject.CreditTerms;
        state.creditEvaluation.creditCheckResult.approved = false;
        HIDE_LOADER(state);
    }

    if (joiceParameters) {
        joiceParameters.forEach(function (item, index) {
            switch (item.Name) {
                case 'JOICE_ID':
                    state.creditEvaluation.creditCheckResult.joiceId = item.Value;
                    break;
                case 'JOICE_STATUS_CODE':
                    state.creditEvaluation.creditCheckResult.joiceStatusCode = item.Value;
                    break;
                case 'JOICE_STATUS_TEXT':
                    state.creditEvaluation.creditCheckResult.joiceStatusText = item.Value;
                    break;
            }
        });
    }

    state.creditEvaluation.creditCheckResult.showDecision = true;
    state.creditEvaluation.creditCheckResult.underwritable = externalCreditCheckResultObject.Underwritable;
}

export const SET_CREDIT_CHECK_RESULT = (state, setCreditCheckResult) => {
    HIDE_LOADER(state);
}

export const GET_TELIA_CONTRACTS = (state) => {
    state.contracts.teliaContracts = null;
    state.contracts.showTeliaContracts = false;
}

export const STORE_TELIA_CONTRACTS = (state, teliaContracts, error) => {
    let binaryData = teliaContracts.BinaryData;
    let fileName = teliaContracts.FileName;
    if (binaryData === "") {
        SHOW_MODAL(state, { 'context': 'contracts', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['refresh'] });
    }
    else {
        state.contracts.showTeliaContracts = true;
        SHOW_CONTRACTS(binaryData, fileName, state);
    }
}

export const GET_TF_CONTRACTS = (state) => {
    state.contracts.tfContracts = null;
    state.contracts.showTFContracts = false;
}

export const STORE_TF_CONTRACTS = (state, tfContracts, error) => {
    let binaryData = tfContracts.BinaryData;
    let fileName = tfContracts.FileName;
    if (binaryData === "") {
        SHOW_MODAL(state, { 'context': 'contracts', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['refresh'] });
    }
    else {
        state.contracts.showTFContracts = true;
        SHOW_CONTRACTS(binaryData, fileName, state);
    }

}
export const GET_SIGN_CONTRACTS = (state, loaderData) => {

    state.pageLoader.showLoader = true;
    state.pageLoader.loaderTitle = loaderData.loaderTitle;
    state.pageLoader.loaderMessage = loaderData.loaderMessage;
    state.pageLoader.loaderSubmitOrderTitle = loaderData.loaderTitle;
    state.pageLoader.loaderSubmitOrderMessage = loaderData.loaderMessage;

    state.contracts.contractsSigned = false;
    state.successfulSigning = null;
}

export const GET_SIGN_CONTRACTS_BY_NAME = (state, loaderData) => {

    state.pageLoader.showLoader = true;
    state.pageLoader.loaderTitle = loaderData.loaderTitle;
    state.pageLoader.loaderMessage = loaderData.loaderMessage;
    state.pageLoader.loaderSubmitOrderTitle = loaderData.loaderTitle;
    state.pageLoader.loaderSubmitOrderMessage = loaderData.loaderMessage;

    state.contracts.contractsSigned = false;
    state.successfulSigning = null;
}

export const STORE_SIGN_CONTRACTS = (state, signContracts, error) => {
    state.contracts.contractsSigned = true;
    state.successfulSigning = signContracts;
}

export const STORE_SIGN_CONTRACTS_BY_NAME = (state, signContractsByName, error) => {
    for (let i = 0; i < state.digitalSigningModal.signatures.length; i++) {
        if (state.digitalSigningModal.signatures[i].FullName == signContractsByName.FullName) {
            state.digitalSigningModal.signatures[i].MarkedAsSigned = true;
            state.digitalSigningModal.signatureLeft--;
            break;
        }
    }
    if (state.digitalSigningModal.signatureLeft == 0) {
        state.contracts.contractsSigned = true;
        state.successfulSigning = true;
    }
    else {
        HIDE_LOADER(state);
    }
}

export const STORE_CHECK_CONTRACTS = (state, checkContractsSignature, error) => {
    state.digitalSigningModal.multipleSignatures = checkContractsSignature.MultipleSignatures;
    state.digitalSigningModal.signatures = checkContractsSignature.Signatures;

    state.digitalSigningModal.signatureLeft = (checkContractsSignature.Signatures != null) ? checkContractsSignature.Signatures.length : 0;
    if (state.digitalSigningModal.multipleSignatures) {
        if (checkContractsSignature.DocumentsSigned || state.digitalSigningModal.signatureLeft == 0) {
            state.contracts.contractsSigned = true;
        }
        else {
            state.contracts.contractsSigned = false;
        }
    }
    else {
        state.contracts.contractsSigned = checkContractsSignature.DocumentsSigned;
    }
}

export const STORE_HAS_ANY_CONTRACT = (state, anyContractCheckResponse, error) => {
    // Are there any contracts?
    state.contracts.hasAnyContract = anyContractCheckResponse.IsContractExisting;
}

export const STORE_HAS_ANY_TELIA_CONTRACT = (state, teliaContractCheckResponse, error) => {
    // Are there any Telia contracts?
    state.contracts.hasAnyTeliaContract = teliaContractCheckResponse.IsContractExisting;
}

export const SKIP_CHECK_CONTRACTS = (state, modifiableByCustomer, error) => {
    state.contracts.contractsSigned = modifiableByCustomer;
}

export const GET_LO_EMAIL = (state) => {
    state.legalOwnerEmailFromCDS = '';
}

export const STORE_LO_EMAIL = (state, legalOwnerEmail) => {
    state.legalOwnerEmailFromCDS = legalOwnerEmail;
    state.contracts.customerEmail = legalOwnerEmail
}

export const SHOW_CONTRACTS = (binaryData, fileName, state) => {
    var byteCharacters = atob(binaryData);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    var blob = new Blob([byteArray], { type: 'application/pdf' });

    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE workaround      
        window.navigator.msSaveOrOpenBlob(blob, fileName + '.pdf');
    }
    else {
        var URL = window.URL;
        var downloadUrl = URL.createObjectURL(blob);
        var newWin = window.open('', '_blank');
        if (newWin === null) {
            var downloadLink = document.createElement('a');
            downloadLink.target = '_blank';
            downloadLink.download = fileName + '.pdf';
            downloadLink.href = downloadUrl;
            document.body.append(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            URL.revokeObjectURL(downloadUrl);
        }
        else {
            newWin.location.href = downloadUrl;
        }
    }
}

export const UPDATE_CONTRACT_DATA = (state, contractData) => {
    switch (contractData.field) {
        case "memo":
            state.contracts.additionalInformation = contractData.value;
            break;
        case "customerEmail":
            state.contracts.customerEmail = contractData.value;
            break;
        case "salesAgentEmail":
            state.contracts.salesAgentEmail = contractData.value;
            break;
    }
}

export const ACCEPT_CTC = (state, checkCTC) => {
    state.contracts.checkCTC = checkCTC;
}

export const ACCEPT_CTFC = (state, checkCTFC) => {
    state.contracts.checkCTFC = checkCTFC;
}

export const SET_SELECTED_SIGNER = (state, signerName) => {
    for (let i = 0; i < state.digitalSigningModal.signatures.length; i++) {
        if (state.digitalSigningModal.signatures[i].FullName == signerName) {
            state.contracts.signatureOwnerFullName = signerName;
            state.digitalSigningModal.selectedSigner = state.digitalSigningModal.signatures[i];
            break;
        }
    }
}

export const IS_PAYMENT_PAGE = (state, checkPaymentPage) => {
    state.pageDetails.isPaymentPage = checkPaymentPage.isPaymentPage;
    state.pageDetails.paymentUrl = checkPaymentPage.paymentUrl;
    state.pageDetails.summaryUrl = checkPaymentPage.summaryUrl;
    state.pageDetails.tangocourl = checkPaymentPage.tangocourl;
    state.pageDetails.tango4durl = checkPaymentPage.tango4durl;
}